import { render, staticRenderFns } from "./ShopItems.vue?vue&type=template&id=3cd4172e&scoped=true"
import script from "./ShopItems.vue?vue&type=script&lang=ts"
export * from "./ShopItems.vue?vue&type=script&lang=ts"
import style0 from "./ShopItems.vue?vue&type=style&index=0&id=3cd4172e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4172e",
  null
  
)

export default component.exports